import React from 'react';
import { Link } from 'react-router';

const getLink = record => {
  let com = null;
  const label = record.operate || '查看';
  switch (record.linkType) {
    case 'BszbSettled':
      com = <Link to={`/incubator/setteled_manage/open/${record.linkUuid}`}>{label}</Link>;
      break;
    case 'BszbBusiness':
      com = <Link to={`/incubator/contract/${record.linkUuid}/info`}>{label}</Link>;
      break;
    case 'BszbOregistapp':
      com = <Link to={`/incubator/oregistapp_manage/open/${record.linkUuid}`}>{label}</Link>;
      break;

    case 'BszbTermination':
      com = <Link to={`/incubator/termination_manage/open/${record.linkUuid}`}>{label}</Link>;
      break;
    case 'BszbBack':
      com = <Link to={`/incubator/back_manage/open/${record.linkUuid}`}>{label}</Link>;
      break;
    case 'BszbIncubRefund':
      com = <Link to={`/incubator/refund_manage/open/${record.linkUuid}`}>{label}</Link>;
      break;
    case 'BszbPayable':
      com = <Link to={`/incubator/bill/${record.linkUuid}/detail`}>{label}</Link>;
      break;
    case 'BszbFuhuaqiSettled':
      com = <Link to={`/incubator/setteled_manage/open/${record.linkUuid}`}>{label}</Link>;
      break;
    default:
      break;
  }
  return com;
};
export default getLink;



// WEBPACK FOOTER //
// ./src/components/incubator/contract/detail/getLink.js